import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailers-top_nav-click';

/**
 * Track the click event on the desktop top nav for all of the L1, L2, and L3 links. The parameter is the path identifier of that link.
 */
export function trackRetailersTopNavClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { customParameterToken },
  });
}
